import React, { useMemo, useState, FC } from 'react';
import { Box, Icon, Avatar, ItemPic } from '@cubeyou-team/hx-react-components';

import { QueryItemContent } from '../../../../../query-item-content';
import MoreInfoModal from './MoreInfoModal';
import { StyledSearchResultsItem, StyledQueryEntityDrag } from './components';
import { ResultSingleItemProps } from './types';

const ResultSingleItem: FC<ResultSingleItemProps> = ({
  item,
  tabIndex,
  variant = 'light',
  infoBox = false,
  isDraggable,
  disabled = false,
  disableModals,
  showModal,
  showStreams,
  onItemSelected,
  onItemDragToggle,
  selectedDataSource,
  ...rest
}) => {
  const [moreInfoOpen, setMoreInfoOpen] = useState(false);
  const [isDragging, SetIsDragging] = useState(false);

  const { label, taxonomy, type, pic, source, followers_count } = item;
  const canInteract = isDraggable && !disabled;

  const itemType = useMemo(() => {
    if (type === 'membership') return 'conversation';

    if (!type.includes('demographic')) return type;

    return 'demographic';
  }, [type]);

  return (
    <Box {...rest}>
      <React.Fragment>
        {moreInfoOpen && (
          <MoreInfoModal
            item={item}
            onClose={() => setMoreInfoOpen(false)}
            showModal={showModal}
            disableModals={disableModals}
          />
        )}
        <StyledSearchResultsItem
          tabIndex={tabIndex}
          /* @ts-ignore */
          isActive={item.isActive}
          key={item.id}
          variant={variant}
          infoBox={infoBox}
          isDraggable={canInteract}
          disabled={disabled}
          draggable={canInteract}
          isDragging={isDragging}
          onDragStart={
            canInteract
              ? (e) => {
                  SetIsDragging(true);
                  onItemDragToggle(true);
                  /* @ts-ignore */
                  e.dataTransfer.setData('itemId', e.target.dataset.itemId);
                  e.dataTransfer.setData('itemInfos', JSON.stringify(item));
                }
              : undefined
          }
          onDragEnd={
            canInteract
              ? () => {
                  SetIsDragging(false);
                  onItemDragToggle(false);
                }
              : undefined
          }
          data-item-id={item.id}
        >
          <div
            className="flex items-center gap-4"
            onClick={() => {
              if (disabled) return;
              onItemSelected(item);
            }}
          >
            {isDraggable && (
              <div className="flex-shrink-0 w-4">
                <StyledQueryEntityDrag>
                  <Icon icon="drag" size="small" variant="dark_lighter" />
                </StyledQueryEntityDrag>
              </div>
            )}
            <div className="flex-1 w-full">
              <QueryItemContent
                itemIcon={
                  itemType !== 'conversation' ? (
                    <ItemPic pic={pic} label={label} size="medium" />
                  ) : (
                    <Avatar
                      hoverEffect="none"
                      initials="C "
                      size="medium"
                      type="circle"
                    />
                  )
                }
                label={label}
                source={source}
                selectedDataSource={selectedDataSource}
                itemType={itemType}
                followers_count={followers_count}
                taxonomy={taxonomy}
                tooltipPosition="left"
                infoBox={infoBox && !disabled}
                setMoreInfoOpen={setMoreInfoOpen}
              />
            </div>
          </div>
        </StyledSearchResultsItem>
      </React.Fragment>
    </Box>
  );
};

export default ResultSingleItem;
